<template>
  <div class="page-container">
    <span class="app-header">
      <UserProfileIcon class="app-header-icon" />
      <span class="app-header-text">{{title}}</span>
    </span>
    <div class="container">
      <user-profile-card v-if="$store.getters.isAuthenticated"/>
      <guest-profile-card v-else />
    </div>
  </div>
</template>

<script>
import UserProfileCard from '@/components/Users/UserProfileCard.vue';
import GuestProfileCard from '@/components/Users/GuestProfileCard.vue';

export default {
  components: {
    GuestProfileCard,
    UserProfileCard
  },
  computed: {
    title() { return document.title; },
  }
}
</script>
